import appInterfaceImg from "../../../../assets/platform-screenshots/demo/marketing/app-interface-hires.png";
import smartSearchImg from "../../../../assets/platform-screenshots/demo/features/smart-search-milk-alice.png";
import shoppingAssistantImg from "../../../../assets/platform-screenshots/demo/features/shopping-assistant.png";
import productAnalyticsImg from "../../../../assets/platform-screenshots/demo/features/product-analytics.png";
import smartCartImg from "../../../../assets/platform-screenshots/demo/features/autofill-cart.png";
import autocompleteSuggestionsImg from "../../../../assets/platform-screenshots/demo/features/autocomplete-suggestions.png";
import cartManagementImg from "../../../../assets/platform-screenshots/demo/features/cart-management.png";
import productRelationshipsImg from "../../../../assets/platform-screenshots/demo/features/product-relationships.png";
import * as React from 'react';
export default {
  appInterfaceImg,
  smartSearchImg,
  shoppingAssistantImg,
  productAnalyticsImg,
  smartCartImg,
  autocompleteSuggestionsImg,
  cartManagementImg,
  productRelationshipsImg,
  React
};